import { Box, Text } from "@chakra-ui/layout";

const Reminders = () => {
    return (
        <Box ml="160px" mt="5%">
            <Text fontSize="2xl">Reminders is not available</Text>
        </Box>
    );
}

export default Reminders;